moduleTabsModule = angular.module('siter.io')

moduleTabsModule.directive "ngTabs", ["$timeout", ($timeout) ->
  scope: true
  restrict: 'EAC'
  controller: ["$scope", ($scope) ->
    $scope.tabs =
      index: 0
      count: 0
    @headIndex = 0
    @bodyIndex = 0

    @getTabHeadIndex = ->
      $scope.tabs.count = ++@headIndex

    @getTabBodyIndex = ->
      ++@bodyIndex

    return
  ]
]
moduleTabsModule.directive "ngTabHead", ["$timeout", ($timeout) ->
  scope: false
  restrict: 'EAC'
  require: '^ngTabs'
  link: (scope, element, attributes, controller) ->
    index = controller.getTabHeadIndex()
    value = attributes.ngTabHead
    active = if /[-*\/%^=!<>&|]/.test(value) then scope.$eval(value) else ! !value
    scope.tabs.index = scope.tabs.index or (if active then index else null)
    element.bind 'click', ->
      scope.tabs.index = index
      scope.$$phase or scope.$apply()
      return
    scope.$watch 'tabs.index', ->
      element.toggleClass 'link_active', scope.tabs.index == index
      return
    return
]

moduleTabsModule.directive "ngTabBody", ["$timeout", ($timeout) ->
  scope: false
  restrict: 'EAC'
  require: '^ngTabs'
  link: (scope, element, attributes, controller) ->
    index = controller.getTabBodyIndex()
    scope.$watch 'tabs.index', ->
      element.toggleClass attributes.ngTabBody + ' ng-show', scope.tabs.index == index
      return
    return
]



// WEBPACK FOOTER //
// ./src/app/common/directives/tabs.directive.coffee